import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './components/Login';
import Register from './components/Register';
import Dashboard from './components/Dashboard';
import Upload from './components/Upload';
import FieldMapping from './components/FieldMapping';
import Templates from './components/Templates';
import TemplateDesigner from './components/TemplateDesigner';
import PDFPreview from './components/PDFPreview';
import PDFGeneration from './components/PDFGeneration';
import JobManagement from './components/JobManagement';
import JobDetails from './components/JobDetails';
import Home from './components/Home';
import Preview from './components/Preview';
import Jobs from './components/Jobs';
import './index.css';

function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" />;
}

function PublicRoute({ children }) {
  const { isAuthenticated } = useAuth();
  return !isAuthenticated ? children : <Navigate to="/dashboard" />;
}

function App() {
  return (
    <AuthProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <div className="min-h-screen bg-gray-50">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route
              path="/login"
              element={
                <PublicRoute>
                  <Login />
                </PublicRoute>
              }
            />
            <Route
              path="/register"
              element={
                <PublicRoute>
                  <Register />
                </PublicRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/upload"
              element={
                <ProtectedRoute>
                  <Upload />
                </ProtectedRoute>
              }
            />            <Route
              path="/mapping/:fileId"
              element={
                <ProtectedRoute>
                  <FieldMapping />
                </ProtectedRoute>
              }
            />
            <Route
              path="/field-mapping"
              element={
                <ProtectedRoute>
                  <FieldMapping />
                </ProtectedRoute>
              }
            />
            <Route
              path="/templates"
              element={
                <ProtectedRoute>
                  <Templates />
                </ProtectedRoute>
              }
            />
            <Route
              path="/templates/:templateId"
              element={
                <ProtectedRoute>
                  <TemplateDesigner />
                </ProtectedRoute>
              }
            />
            <Route
              path="/preview/:templateId"
              element={
                <ProtectedRoute>
                  <PDFPreview />
                </ProtectedRoute>
              }
            />
            <Route
              path="/generate/:templateId"
              element={
                <ProtectedRoute>
                  <PDFGeneration />
                </ProtectedRoute>
              }
            />            <Route
              path="/jobs"
              element={
                <ProtectedRoute>
                  <Jobs />
                </ProtectedRoute>
              }
            />
            <Route
              path="/job-details/:jobId"
              element={
                <ProtectedRoute>
                  <JobDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/preview"
              element={
                <ProtectedRoute>
                  <Preview />
                </ProtectedRoute>
              }
            />
            <Route
              path="/template-designer"
              element={
                <ProtectedRoute>
                  <TemplateDesigner />
                </ProtectedRoute>
              }
            />
            <Route
              path="/jobs"
              element={
                <ProtectedRoute>
                  <Jobs />
                </ProtectedRoute>
              }
            />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
